/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const DEFAULT_APP_CONFIG = {
  servers: {
    graphql: [
      {
        name: "graphql-gateway",
        // url: "http://localhost:5002/",
        // url: "https://ca-central-gem-01.vlinder.io/redants/core/", // redants Production Server
        //  url: "https://gem-be.vlinderserver.online/bliss/core/gql/", // bliss stagging
        url: "https://gem-be.vlinderserver.online/core/gql/", // tribe Staging Server
        // url: "https://gem-be.vlinderserver.online/thelostribe/core/gql/", // LT Staging Server
      },
    ],
    rest: {
      loginServer: {
        // baseURL: "http://localhost:5005/",
        // baseURL: "https://ca-central-gem-01.vlinder.io/redants/login/", // redants Production Server
        //  baseURL: "https://gem-be.vlinderserver.online/bliss/login/rest/", // bliss Staging Server
        baseURL: "https://gem-be.vlinderserver.online/login/rest/", // tribe Staging Server
        // baseURL: "https://gem-be.vlinderserver.online/thelostribe/login/rest/", // LT Staging Server
      },
    },
  },
  defaultLoading: {
    // image:
    // "https://s3.ca-central-1.amazonaws.com/io.vlinder.tribe/band_logos/tribe_logo.png",
    titleNormalText: "Loading",
    titleBoldText: "Page...",
    description: "This might take a few seconds, Please wait !",
  },
  platformSemantics: {
    semantics: {
      holder: "",
      holders: "",
      issuer: "",
    },
    Holders: {
      title: "",
    },
    HoldersGroups: {
      title: " ",
    },
    DashboardIssuerAnalysis: {
      title: "",
    },
  },
};
